import { useEffect } from "react";
import { useAuth } from "react-oidc-context";
import { CheckCircleIcon } from "./icons";
import InfoScreen from "./InfoScreen";
import { useI18n } from "../i18n";

export default function LogoutSuccess() {
  const { t } = useI18n();
  const auth = useAuth();

  useEffect(() => {
    auth.removeUser();
  }, [auth]);

  useEffect(() => {
    // Redirect to home page after 5 seconds
    const timer = setTimeout(() => {
      window.location.href = "/";
    }, 5000);

    return () => clearTimeout(timer);
  }, []);

  return (
    <InfoScreen
      icon={<CheckCircleIcon className="w-12 h-12 text-success" />}
      title={t("logout.title")}
    >
      <p className="opacity-70 mb-6">{t("logout.body")}</p>
      <a className="btn btn-primary" href="/">
        {t("logout.signBackIn")}
      </a>
    </InfoScreen>
  );
}
